import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';

export default function TrendingRank() {
  const trending = getTrendingArticles(10);

  return (
    <section className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl font-bold text-foreground-900">热搜排行榜</h2>
          <span className="text-xs text-foreground-400 ml-2">实时更新</span>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/70 transition-colors cursor-pointer ${
                index < trending.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg font-heading font-bold ${
                index === 0
                  ? 'bg-primary-500 text-white text-lg'
                  : index === 1
                  ? 'bg-primary-400 text-white text-lg'
                  : index === 2
                  ? 'bg-primary-300 text-white text-lg'
                  : 'bg-background-100 text-foreground-500 text-sm'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-1 hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-1 text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{(article.readCount / 10000).toFixed(1)}万阅读</span>
                </div>
              </div>
              {index < 3 && (
                <span className="flex-shrink-0 px-2 py-1 rounded-full bg-primary-50 text-primary-600 text-xs font-medium">
                  热
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}